// Generated from SVG to React Component
import React, { SVGProps } from "react";

export const Refresh1Md = ({ color = "black", ...props }: SVGProps<SVGSVGElement>) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M7.12197 16.4728C9.12125 17.3598 11.5025 17.3116 13.5416 16.1343C16.9295 14.1783 18.0903 9.84618 16.1343 6.45828L15.926 6.09743M3.86522 13.5417C1.90921 10.1538 3.06999 5.8217 6.4579 3.8657C8.49705 2.68839 10.8783 2.64022 12.8775 3.52719M2.07764 13.6114L4.35435 14.2215L4.96439 11.9447M15.0353 8.05479L15.6454 5.77808L17.9221 6.38813" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

);
